/**
 * 동시성 제한 병렬 실행 유틸리티
 * 외부 라이브러리 없이 p-map 패턴 구현
 */

/**
 * 배열의 각 항목에 대해 동시성을 제한하여 비동기 함수를 병렬 실행
 *
 * @param items - 처리할 항목 배열
 * @param fn - 각 항목에 적용할 비동기 함수
 * @param concurrency - 최대 동시 실행 수
 * @returns 각 항목의 결과 (PromiseSettledResult 배열)
 */
export async function mapSettledWithConcurrency<T, R>(
  items: T[],
  fn: (item: T, index: number) => Promise<R>,
  concurrency: number
): Promise<PromiseSettledResult<R>[]> {
  const results: PromiseSettledResult<R>[] = new Array(items.length);
  let nextIndex = 0;

  async function worker() {
    while (nextIndex < items.length) {
      const i = nextIndex++;
      try {
        const value = await fn(items[i], i);
        results[i] = { status: "fulfilled", value };
      } catch (reason) {
        results[i] = { status: "rejected", reason };
      }
    }
  }

  const workerCount = Math.min(Math.max(1, concurrency), items.length);
  await Promise.all(Array.from({ length: workerCount }, () => worker()));

  return results;
}
